import taxSettingsByLocale from '../flags_variants/tax_settings.json'

/**
 * Perfil de sesión en memoria para la UI de Torre (remediación auditoría RBAC).
 *
 * Modelo de seguridad:
 * - RBAC, datos personales y contexto de negocio para la UI viven aquí tras login/bootstrap,
 *   cargados desde GET /users/current — no desde cookies editables por el cliente.
 * - La autorización real la aplica solo platform-admin-backend; este store es estado de presentación.
 * - Los nombres en COOKIES_TO_PURGE_ON_LOGIN ya no los escribe la app; se eliminan al iniciar sesión
 *   o al arrancar para que un estado viejo del navegador no falsifique permisos.
 */

/** Cookies que Torre escribía antes con JS; no deben usarse para decisiones de seguridad. */
export const COOKIES_TO_PURGE_ON_LOGIN = [
  'business_id',
  'business_tenant_uid',
  'business_name',
  'business_url',
  'user_name',
  'user_email',
  'user_role',
  'id',
  'intl_locale',
  'intl_currency',
  'mfa_enabled',
  'security_configured',
  'rbac_permissions',
  'rbac_roles',
  'rbac_is_admin',
  'can_manage_rbac',
  'warehouse_uid',
  'warehouse_name',
  'tax_settings',
  'rbac_grantable_sensitive_families'
]

const COOKIES_TO_PURGE_SET = new Set(COOKIES_TO_PURGE_ON_LOGIN)

let profile = null

export function getSessionProfile() {
  return profile
}

export function mergeSessionProfile(patch) {
  if (!patch || typeof patch !== 'object') return
  profile = { ...(profile || {}), ...patch }
}

export function setSessionProfileFromLogin(payload = {}, { email } = {}) {
  const resolvedEmail = email ?? payload.email
  profile = {
    id: payload.id,
    email: resolvedEmail,
    user_name: payload.user_name,
    user_email: resolvedEmail ?? payload.user_email,
    business: payload.business ?? payload.business_name,
    business_url: payload.business_url,
    intl_locale: payload.intl_locale,
    intl_currency: payload.intl_currency,
    tax_settings: taxSettingsByLocale[payload.intl_locale] || taxSettingsByLocale.default,
    mfa_enabled: payload.mfa_enabled,
    security_configured: payload.security_configured,
    warehouse_uid: payload.warehouse_uid,
    warehouse_name: payload.warehouse_name,
    rbac_permissions: payload.rbac_permissions || [],
    rbac_roles: payload.rbac_roles || [],
    rbac_is_admin: !!payload.rbac_is_admin,
    can_manage_rbac: !!payload.can_manage_rbac || !!payload.rbac_is_admin
  }
}

export function clearSessionProfile() {
  // Avisa que se limpió la sesión para cerrar conexiones de reportes y cancelar/limpiar sus descargas.
  // La comprobación de window evita emitir el evento fuera del navegador.
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('ubiqua-session-cleared'))
  profile = null
}

export function loadSessionField(key) {
  if (!profile) return undefined
  if (!Object.prototype.hasOwnProperty.call(profile, key)) return undefined
  return profile[key]
}

/** Indica si esta cookie no debe leerse del documento (auditoría: sin RBAC/PII en cookies). */
export function isPurgedClientCookieName(name) {
  return COOKIES_TO_PURGE_SET.has(name)
}

/** Etiquetas fiscales disponibles incluso antes de restaurar el perfil. */
export function getTaxSettings() {
  return loadSessionField('tax_settings') || taxSettingsByLocale.default
}
